<template>
  <div id="not-found-view">

    <!-- CONTENT -->

    <div id="wideContent">
      <div class="box">
        <div class="boxContent">

          <h1>Stránka nebyla nenalezena</h1>

          <p>
            Stránka, na kterou jste se pokusili přejít neexistuje.
          </p>

          <p>
            <a href="/">Klikněte pro přechod na hlavní stránku webu.</a>
          </p>

          <div style="height: 500px">
            <!-- / -->
          </div>

          <div class="cleaner">
            <!-- / -->
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'not-found-view'
  }
</script>



// WEBPACK FOOTER //
// NotFoundView.vue?2555a26a